import { Field, Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import { Button, Input, ModalBox, Textarea, useModalContext } from '@fourthwall/components'

import * as S from './CreateAppModal.styled'

type CreateAppFormValues = {
  name: string
  description: string
  redirectUris: string[]
}

type CreateAppModalProps = {
  onSave: (name: string, description: string, redirectUris: string[]) => void
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('App name is required'),
  description: Yup.string(),
})

const getInitialValues = (): CreateAppFormValues => ({
  name: '',
  description: '',
  redirectUris: [],
})

export const CreateAppModal = ({ onSave }: CreateAppModalProps) => {
  const { close } = useModalContext()

  const handleSubmit = (values: CreateAppFormValues) => {
    onSave(values.name, values.description, values.redirectUris)
    close()
  }

  const handleCancel = () => {
    close()
  }

  return (
    <Formik<CreateAppFormValues>
      initialValues={getInitialValues()}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid, dirty, submitForm }) => (
        <Form>
          <ModalBox
            title="Create New App"
            onClose={handleCancel}
            buttons={[
              <Button
                label="Create"
                appearance="primary"
                onClick={submitForm}
                disabled={!isValid || !dirty}
              />,
            ]}
          >
            <S.Container>
              <S.FieldsContainer>
                <Field
                  component={Input}
                  name="name"
                  label="App Name"
                  placeholder="Enter app name"
                />
                <Field
                  component={Textarea}
                  name="description"
                  label="Description"
                  placeholder="Enter app description"
                />
              </S.FieldsContainer>
            </S.Container>
          </ModalBox>
        </Form>
      )}
    </Formik>
  )
}
